import React from "react"
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb"
import useMediaQuery from "./../../../shared/utils/useMediaQuery"

import imgHeaderBanner from "./../../../assets/images/packaging-delivery/banner.png"
import imgHeaderBannerDesk from "./../../../assets/images/packaging-delivery/banner-desktop-empaques.png"
import imgHeaderBannerMob from "./../../../assets/images/packaging-delivery/banner-mobile-empaques.png"

import PackagingDeliverySection1 from "../../molecules/packaging-delivery-section-1/packaging-delivery-section-1"
import PackagingDeliverySection2 from "../../molecules/packaging-delivery-section-2/packaging-delivery-section-2"
import PackagingDeliverySection3 from "../../molecules/packaging-delivery-section-3/packaging-delivery-section-3"
import PackagingDeliverySection4 from "../../molecules/packaging-delivery-section-4/packaging-delivery-section-4"

import "./packaging-delivery.scss"
import PackagingDeliverySection5 from "../../molecules/packaging-delivery-section-5/packaging-delivery-section-5"
import PackagingDeliverySection6 from "../../molecules/packaging-delivery-section-6/packaging-delivery-section-6"
import PackagingDeliverySectionVideo
  from "../../molecules/packaging-delivery-section-video/packaging-delivery-section-video"


export function PackagingDelivery() {
  const isMobile = useMediaQuery()

  return (
    <div className="f-packaging-delivery">
      <div className="f-packaging-delivery__container">
        <div className="f-breadcrum-position">
          <Breadcrumb mobile={isMobile} />
        </div>

        <div className="f-packaging-delivery__banner">

          <div className="f-header-articles-container">

            <div className="f-header-articles-content-section">
              <img className="f-banner-main-article"
                   src={isMobile ? imgHeaderBannerMob : imgHeaderBannerDesk}
                   alt="Dale una nueva vida a tus empaques"
                   height={isMobile ? 300 : 250}
              />

            </div>

          </div>

        </div>


        {/*
        <div className="f-packaging-delivery__header">
          <div className="f-packaging-delivery__header__container">
            <h1 className="f-packaging-delivery__header__title">
              Dale una{" "}
              <span className="f-packaging-delivery__header__title__span--yellow-fill f-packaging-delivery__header__title__span--bold f-packaging-delivery__header__title__span--pink">
                nueva vida
              </span>{" "}
              a tus{" "}
              <span className="f-packaging-delivery__header__title__span--bold">
                empaques <br />
                Nosotras:
              </span>{" "}
              <span className="f-packaging-delivery__header__title__span--pink f-packaging-delivery__header__title__span--bold">
                gana puntos para ti
              </span>{" "}
              <br />y loving para el planeta.
            </h1>
            <img
              className="f-packaging-delivery__header__img"
              src={imgHeaderBanner}
              alt="Referente: Empaques y un personaje del planeta"
            />
          </div>
        </div>

        */}
        <PackagingDeliverySectionVideo />
        <PackagingDeliverySection1 />
        <PackagingDeliverySection2 />
        <PackagingDeliverySection3 />
        <PackagingDeliverySection4 />
        <PackagingDeliverySection5 />
        <PackagingDeliverySection6 />
      </div>
    </div>
  )
}
